import Vue from "vue";
import DatePicker from "vue2-datepicker";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";
import Customers from "@/components/widgets/delivery";
import Customers2 from "@/components/widgets/customers";
import DepositDocuments from "@/components/widgets/tax-invoice-full";
import DepositPicker from "@/components/widgets/deposits";
import DepositTaxInvoicePicker from "@/components/widgets/deposit-tax-invoices";

import Loading from "@/components/widgets/Loading.vue";
import moment from "moment";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  components: {
    Customers,
    Customers2,
    DatePicker,
    Paginate,
    Loading,
    DepositDocuments,
    DepositPicker,
    DepositTaxInvoicePicker
  },
  data: function () {
    return {
      depositDocumentEnabled: false,
      depositImportEnabled: false,
      depositTaxInvoiceEnabled: false,
      is_deposit: false,
      isEdit: false,
      invoiceUUID: null,
      originalGrandTotal: null, // สุทธิเดิมของใบ (โหมดแก้ไข) — จูนส่วนลดสตางค์แล้วสุทธิต้องนิ่ง
      uploadedFiles: [],
      selectedRows: [],
      isCustomerPopupOpen: false,
      isCustomerPopupOpen2: false,
      deposit_document_no: null,
      deposit_document_id: null,
      // มัดจำจากใบกำกับภาษีมัดจำ (AI) — คนละคอลัมน์กับใบ IV-มัดจำ ใช้ได้ทางเดียว
      deposit_tax_invoice_no: null,
      deposit_tax_invoice_id: null,
      bank_account_list: [],
      vatRate: 0.07,
      form: {
        document_no: "",
        document_date: "",
        remark: "",
        vat_type: 1,
      },
      loading: false,
      customer_id: null,
      customer: {
        customer: {
          code: "",
          name: "",
          phone_number: "",
          company_name: "",
          tax_id: "",
          address: "",
        },
        document_no: "",
      },
      busy: false,
      advanced: false,
      status: null,
      createId: null,
      openedCreate: false,
      sortDesc: false,
      totalItem: 0,
      apiStatus: "ไม่พบข้อมูล",
      doc: {
        start: null,
        end: null,
      },
      duedate: {
        start: null,
        end: null,
      },
      debtStatus: [
        { text: "On hold", value: "onhold" },
        { text: "ค้างชำระ", value: "overdue" },
        { text: "ยกเลิก", value: "cancel" },
        { text: "ชำระแล้ว", value: "success" },
      ],
      perPage: 6,
      sortBy: "name",
      currentPage: 1,
      currentData: {},
      keyword: "",
      deposit: 0,
      deposit_ref_grand: null, // grand (รวม VAT) ของใบกำกับมัดจำอ้างอิง — ใช้ยึดเงินจริงกันเศษสตางค์
      itemsTotal: 0,
      discount: 0,
      subtotal: 0,
      vat: 0,
      total: 0,
      fields: [
        {
          key: "idx",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          thStyle: { width: "5%" },
        },
        {
          key: "description",
          label: "รายละเอียด",
          sortable: false,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          thStyle: { width: "20%" },
        },
        {
          key: "length",
          label: "ความยาว",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "quantity",
          label: "จำนวน",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "unit_name",
          label: "หน่วย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "total_length",
          label: "ปริมาณรวม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "unit_price",
          label: "ราคา/หน่วย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "total_price",
          label: "ราคารวม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: false,
          class: "text-right",
          thStyle: { width: "15%" },
        },
        {
          key: "action",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          thStyle: { width: "5%" },
        },
      ],
      items: [],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  watch: {
    is_deposit(val) {
      if (val) {
        // ถ้าเป็นใบมัดจำ → ล้างมัดจำที่ผูกอยู่ออก เพราะไม่สามารถหักมัดจำจากตัวเองได้
        this.deposit = 0;
        this.deposit_document_no = null;
        this.deposit_document_id = null;
        this.deposit_tax_invoice_no = null;
        this.deposit_tax_invoice_id = null;
        this.deposit_ref_grand = null;
        this.depositDocumentEnabled = false;
        this.depositTaxInvoiceEnabled = false;
        this.calculateTotals();
      }
    },
  },
  mounted() {
    const uuid = this.$route.params.id;
    if (uuid) {
      this.isEdit = true;
      this.invoiceUUID = uuid;
      this.loadInvoice(uuid);
    }
  },
  methods: {
    async loadInvoice(uuid) {
      try {
        this.loading = true;
        this.busy = true;

        const url = `${Vue.prototype.$host}/api/v1/document/full-tax-invoice/${uuid}`;
        const res = await Vue.prototype.$axios.get(url);

        this.loading = false;
        this.busy = false;

        const inv = res?.data?.data;
        if (!inv) {
          this.onExceptionHandler("ไม่พบใบกำกับภาษี");
          return;
        }

        // ----- หัวเอกสาร -----
        this.form.document_no = inv.document_no || "";
        this.form.document_date = inv.document_date ? new Date(inv.document_date) : null;
        // เก็บสุทธิเดิม — จูนส่วนลดระดับสตางค์แล้วยอดสุทธิที่ตกลงกับลูกค้าต้องไม่ขยับ
        this.originalGrandTotal = this.toNum(inv.grand_total ?? 0);
        this.form.remark = inv.remark || "";
        this.form.vat_type = Number(inv.vat_type || 1);

        // ถ้ามีส่วนลด
        this.discount = this.toNum(inv.discount ?? 0)

        // ✅ โหลดยอดมัดจำจาก backend
        this.deposit = this.toNum(inv.deposit ?? 0)
        this.deposit_ref_grand = inv.deposit_ref_grand ? this.toNum(inv.deposit_ref_grand) : null

        // ✅ ใช้เลขที่เอกสารมัดจำให้ถูกต้อง (ไม่ใช่ document_no หลัก)
        this.deposit_document_no = inv.deposit_document_no || null
        this.deposit_document_id = inv.deposit_document_id || null
        this.deposit_tax_invoice_no = inv.deposit_tax_invoice_no || null
        this.deposit_tax_invoice_id = inv.deposit_tax_invoice_id || null
        this.is_deposit = !!inv.is_deposit

        // ถ้าแบ็กเอนด์ส่ง vat_rate = 7 ให้แปลงเป็น 0.07
        if (inv.vat_rate != null) {
          const vr = this.toNum(inv.vat_rate);
          this.vatRate = vr > 1 ? vr / 100 : vr; // รองรับทั้ง 7 และ 0.07
        }

        const rawVatType = inv.vat_type;
        const parsed = parseInt(rawVatType, 10);
        this.form.vat_type = [0, 1, 2].includes(parsed) ? parsed : 1;

        // ลูกค้า
        this.customer_id = inv.customer_id || null;
        const c = inv.customer_detail || {};
        this.customer = {
          ...this.customer,
          customer: {
            code: c.code || "",
            name: c.name || c.company_name || "",
            phone_number: c.phone_number || "",
            company_name: c.company_name || "",
            tax_id: c.tax_id || "",
            address: c.address || "",
          },
          document_no: inv.document_no || "-",
          id: inv.delivery_document_id || null,
        };

        // ----- รายการ -----
        const loaded = Array.isArray(inv.items) ? inv.items : [];
        this.items = loaded.map((it, i) => {
          // description จาก DB รวม code_description ไว้แล้วตอน prefill → ห้าม prepend ซ้ำ
          // normalize ตัวเลขทั้งหมด
          const length = this.toNum(it.length);
          const quantity = this.toNum(it.qty != null ? it.qty : it.quantity);
          const unit_price = this.toNum(it.unit_price);
          const unit_name = it.unit_name || "";
          const discount = this.toNum(it.discount);
          const tax_rate_raw = (it.tax_rate != null) ? this.toNum(it.tax_rate) : 7;
          const tax_rate = tax_rate_raw > 1 ? tax_rate_raw : tax_rate_raw * 100; // เก็บเป็นเปอร์เซ็นต์ 7

          // คิดต่อแถวจากฐาน length/quantity/unit_price ทุกครั้ง
          const tmp = { length, quantity, unit_price };
          const { total_length, total_price } = this.computeLine(tmp);

          return {
            idx: i + 1,
            code: it.code || "",
            code_description: it.code_description || "",
            description: it.description || "",

            length,
            quantity,
            total_length,
            unit_price,
            total_price,

            unit_name,
            type: it.type || 1,
            sku_id: it.sku_id || null,
            discount,
            tax_rate,    // เก็บเป็น 7 เพื่อส่งกลับฝั่ง API ได้
            remark: it.remark || null,
          };
        });

        // สรุปรวมหลัง set items แล้ว
        this.$nextTick(() => {
          this.calculateTotals();
        });

      } catch (err) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "เกิดข้อผิดพลาด";
        this.onExceptionHandler(err?.response?.data?.message || "เกิดข้อผิดพลาด");
      }
    },

    onConfirmUpdate() {
      this.$swal({
        width: "29rem",
        padding: "1.825em",
        html:
          '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">ยืนยันการแก้ไข</span>' +
          '<span class="text-base text-left text-gray-500">คุณต้องการบันทึกการแก้ไขใบกำกับภาษี (เต็มรูปแบบ) นี้หรือไม่</span>' +
          "</div>" +
          "</div>",
        customClass: {
          popup: "swal2-custom-rounded",
          closeButton: "text-3xl swal2-custom-close",
          actions: "justify-content-end",
          contant: "d-flex flex-row justify-content-around px-2",
          title: "d-none",
          confirmButton:
            "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton:
            "btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
        },
        allowOutsideClick: false,
        focusConfirm: false,
        cancelButtonColor: "#dc4a38",
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        showCancelButton: true,
        showCloseButton: true,
      }).then((confirm) => {
        if (confirm.value) {
          this.onUpdate();
        }
      });
    },

    async onUpdate() {
      try {
        this.loading = true;
        this.busy = true;

        const payload = {
          remark: this.form.remark ?? "",
          document_date: this.form.document_date
            ? moment(this.form.document_date).format("YYYY-MM-DD")
            : null,
          customer_id: this.customer_id || null,
          vat_type: this.form.vat_type,

          // ✅ ส่งยอดมัดจำไปให้ backend
          deposit: Number(this.deposit || 0),
          discount: Number(this.discount || 0),
          items_total: Number(this.itemsTotal || 0),
          subtotal: Number(this.subtotal || 0),
          vat: Number(this.vat || 0),
          grand_total: Number(this.total || 0),

          // ✅ ถ้ามีเอกสารมัดจำ ให้ส่งไปด้วย
          deposit_document_no: this.deposit_document_no || null,
          deposit_document_id: this.deposit_document_id || null,
          // มัดจำจากใบกำกับภาษีมัดจำ (AI) — คนละคอลัมน์ ใช้ได้ทางเดียว
          deposit_tax_invoice_no: this.deposit_tax_invoice_no || null,
          deposit_tax_invoice_id: this.deposit_tax_invoice_id || null,

          is_deposit: this.is_deposit,

          // ✅ ถ้ามีใบส่งของที่ผูกอยู่ ให้ส่งไปอัปเดตด้วย (ตามที่ create ใช้)
          delivery_document_id: this.customer?.id || null,

          // ถ้าอยากให้แก้ discount ได้ด้วย ก็ใส่บรรทัดนี้ (ถ้ามี this.discount ใน data/form)
          // discount: Number(this.discount || 0),

          items: this.items.map((x) => ({
            code: x.code ?? "",
            code_description: x.code_description ?? "",
            description: x.description ?? "",
            length: Number(x.length || 0),
            quantity: Number(x.quantity || 0),
            total_length: Number(x.total_length || 0),
            unit_price: Number(x.unit_price || 0),
            total_price: Number(x.total_price || 0),
            unit_name: x.unit_name ?? "",
            type: x.type ?? 1,
            sku_id: x.sku_id ?? null,
            discount: Number(x.discount || 0),
            tax_rate: typeof x.tax_rate === "number" ? x.tax_rate : 7,
            remark: x.remark ?? null,
          })),
        };

        const url = `${Vue.prototype.$host}/api/v1/document/full-tax-invoice/${this.invoiceUUID}`;
        const res = await Vue.prototype.$axios.put(url, payload);

        this.loading = false;
        this.busy = false;

        if (res) {
          this.$swal.close();
          this.$swal.fire({
            icon: "success",
            title: "บันทึกสำเร็จ",
            showConfirmButton: false,
            timer: 1200,
          });
          setTimeout(() => {
            window.close();
          }, 1000);
        }
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "เกิดข้อผิดพลาด";
        this.onExceptionHandler(
          error?.response?.data?.message || "เกิดข้อผิดพลาด"
        );
      }
    },
    validateItemsAndSum() {
      let total = 0;
      let allValid = true;

      this.items.forEach((item, index) => {
        const price = parseFloat(item.total_price);
        if (isNaN(price) || price < 0) {
          allValid = false;
          // Mark item as invalid (optional if you want to show UI error)
          this.$set(item, "invalidPrice", true);
        } else {
          this.$set(item, "invalidPrice", false);
          total += price;
        }
      });
    },
    onDeliveryDocumentSelected(e) {
      this.isCustomerPopupOpen = false;

      if (e.data) {
        this.customer = e.data;
        this.customer_id = e.data.customer.id;
      }
      //โหลดรายการ
      const id = e.data.id
      this.onLoadBillItem(id)
    },
    onDepositInvoiceSelected(e) {
      this.depositImportEnabled = false;
      if (!e.status || !e.data) return;
      this.customer_id = this.customer_id || e.data.customer_id;
      this.onLoadDepositItems(e.data.id);
    },
    async onLoadDepositItems(id) {
      try {
        this.loading = true;
        this.busy = true;
        const result = await Vue.prototype.$axios.get(
          `${Vue.prototype.$host}/api/v1/document/tax-invoice-deposit-items/${id}`
        );
        this.loading = false;
        this.busy = false;
        const loaded = Array.isArray(result.data?.data) ? result.data.data : [];
        this.items = loaded.map((item, i) => {
          const codePart = item.code_description ? `${item.code_description} ` : '';
          const descPart = item.description || '';
          return {
            ...item,
            idx: i + 1,
            description: `${codePart}${descPart}`.trim(),
          };
        });
        const doc = result.data?.document;
        if (doc?.customer) {
          this.customer_id = doc.customer_id;
          this.$set(this, 'customer', {
            ...this.customer,
            document_no: '-',
            customer: Object.assign({}, doc.customer),
          });
        }
        this.is_deposit = true;
        this.calculateTotals();
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.onExceptionHandler(error.response?.data?.message || 'เกิดข้อผิดพลาด');
      }
    },
    onCustomerSelected(e) {
      this.isCustomerPopupOpen2 = false;

      if (e.data) {
        this.customer.document_no = "-";
        this.customer.customer = e.data;
        this.customer_id = e.data.id;
      }
    },
    onRemove(index) {
      if (index >= 0 && index < this.items.length) {
        this.items.splice(index, 1);
      }
      this.calculateTotals()
    },
    async requestCreditNote() {
      // 1. Validation เดิม
      if (!this.form.document_date) {
        this.onExceptionHandler("กรุณาเลือกวันทีเอกสาร");
        return;
      }
      if (!this.customer_id) {
        this.onExceptionHandler("กรุณาเลือกใบส่งสินค้าหรือเลือกลูกค้า");
        return;
      }
      if (this.items.length === 0) {
        this.onExceptionHandler("กรุณาใส่รายการอย่างน้อย 1 รายการ");
        return;
      }

      const invalidItem = this.items.find((item) => {
        return item.description === "" || Number(item.total_price) === 0;
      });
      if (invalidItem) {
        this.onExceptionHandler(
          "กรุณาระบุรายละเอียดและราคาสำหรับทุกรายการอย่างถูกต้อง"
        );
        return;
      }

      this.validateItemsAndSum();

      if (this.isEdit) {
        this.onConfirmUpdate();
      } else {
        this.onConfirmCreate();
      }
    },
    async onConfirmCreate() {
      this.$swal({
        width: "29rem",
        padding: "1.825em",
        html:
          '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
          '<span class="text-base text-left text-gray-500">ท่านต้องการยืนยันการสร้าง `ใบกำกับภาษี (เต็มรูปแบบ)` ใช่หรือไม่</span>' +
          "</div>" +
          "</div>",
        customClass: {
          popup: "swal2-custom-rounded",
          closeButton: "text-3xl swal2-custom-close",
          actions: "justify-content-end",
          contant: "d-flex flex-row justify-content-around px-2",
          title: "d-none",
          confirmButton:
            "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton:
            "btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
        },
        allowOutsideClick: false,
        focusConfirm: false,
        cancelButtonColor: "#dc4a38",
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        showCancelButton: true,
        showCloseButton: true,
      }).then((confirm) => {
        if (confirm.value) {
          this.onCreate();
        }
      });
    },
    async onLoadBillItem(id) {
      try {
        this.loading = true;
        this.busy = true;

        let result = await Vue.prototype.$axios.get(
          `${Vue.prototype.$host}/api/v1/document/tax-invoice-prefill-item/${id}`
        );

        this.loading = false;
        this.busy = false;

        if (result) {
          const loaded = Array.isArray(result.data?.data) ? result.data.data : [];
          // merge code_description into description on load
          this.items = loaded.map((item, i) => {
            const codePart = item.code_description ? `${item.code_description} ` : "";
            const descPart = item.description || "";
            return {
              ...item,
              // Optional: keep your idx if the table uses it
              idx: i + 1,
              description: `${codePart}${descPart}`.trim()
            };
          });
          this.calculateTotals()
        }
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "เกิดข้อผิดพลาด";
        this.onExceptionHandler(
          error.response?.data?.message || "เกิดข้อผิดพลาด"
        );
      }
    },
    async onCreate() {
      const formData = new FormData();
      formData.append("remark", this.form.remark ?? "");
      formData.append(
        "document_date",
        this.form.document_date
          ? moment(this.form.document_date).format("YYYY-MM-DD")
          : null
      );
      formData.append("customer_id", this.customer_id);
      if (this.customer.id) {
        formData.append("delivery_document_id", this.customer.id);
      }
      formData.append("items", JSON.stringify(this.items));

      formData.append("items_total", this.itemsTotal);
      formData.append("discount", this.discount);
      formData.append("subtotal", this.subtotal);
      formData.append("deposit", this.deposit);
      if (this.deposit_document_no) {
        formData.append("deposit_document_no", this.deposit_document_no);
      }
      if (this.deposit_document_id) {
        formData.append("deposit_document_id", this.deposit_document_id);
      }
      // ใบกำกับภาษีมัดจำ (AI) เก็บคนละ reference กับใบ IV มัดจำ
      // ต้องส่งทั้งเลขและ id ตอนสร้างด้วย ไม่เช่นนั้นหน้ารายการจะรู้เพียงยอดมัดจำ
      // แต่ไม่รู้ว่าหักมาจากใบ AI ใด (ฝั่ง update ส่งสองฟิลด์นี้อยู่แล้ว)
      if (this.deposit_tax_invoice_no) {
        formData.append("deposit_tax_invoice_no", this.deposit_tax_invoice_no);
      }
      if (this.deposit_tax_invoice_id) {
        formData.append("deposit_tax_invoice_id", this.deposit_tax_invoice_id);
      }
      formData.append("vat", this.vat);
      formData.append("vat_type", this.form.vat_type);
      formData.append("grand_total", this.total);
      formData.append("is_deposit", this.is_deposit ? "1" : "0");

      try {
        this.loading = true;
        this.busy = true;

        let result = await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/document/tax-invoice-full`,
          formData
        );

        this.loading = false;
        this.busy = false;

        if (result) {
          this.uploadedFiles = [];
          alert("สร้างใบกำกับภาษี (เต็มรูปแบบ) สำเร็จ");
          this.$router.push("/tax/full");
        }
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "เกิดข้อผิดพลาด";
        this.onExceptionHandler(
          error.response?.data?.message || "เกิดข้อผิดพลาด"
        );
      }
    },
    onopenproduct() {
      var blank_row = {
        code: "",
        code_description: "",
        description: "",
        length: "0",
        quantity: "0",
        total_length: "0",
        unit_price: "0",
        total_price: "0",
        unit_name: "",
        type: 1,
        sku_id: null,
        is_insulator: false,
        isPE: true,
        isPU: false,
        thickness: null,
        insulator_material: null,
        insulator_detail: "",
        insulator_head: "",
        insulator_tail: "",

        is_curve: false,
        curve_weight: "",
        curve_start: "",
        curve_gap: "",
        curve_repeat: "",
      };
      this.items.splice(0, 0, blank_row);
    },
    onCopy(index) {
      const currentProducts = this.items;
      const targetProduct = currentProducts[index];

      var copied_row = {
        code: targetProduct.code,
        code_description: targetProduct.code_description,
        description: targetProduct.description,
        length: targetProduct.length,
        quantity: targetProduct.quantity,
        total_length: targetProduct.total_length,
        unit_price: targetProduct.unit_price,
        total_price: targetProduct.total_price,
        unit_name: targetProduct.unit_name,
        type: targetProduct.type,
        sku_id: targetProduct.sku_id,
        is_insulator: targetProduct.is_insulator,
        isPE: targetProduct.isPE,
        isPU: targetProduct.isPU,
        thickness: targetProduct.thickness,
        insulator_material: targetProduct.insulator_material,
        insulator_detail: targetProduct.insulator_detail,
        insulator_head: targetProduct.insulator_head,
        insulator_tail: targetProduct.insulator_tail,

        is_curve: targetProduct.is_curve,
        curve_weight: targetProduct.curve_weight,
        curve_start: targetProduct.curve_start,
        curve_gap: targetProduct.curve_gap,
        curve_repeat: targetProduct.curve_repeat,
      };
      this.items.splice(index + 1, 0, copied_row);

      this.calculateTotals();
    },
    lengthChanged(event, index) {
      const value = parseFloat(event) || 0;
      this.items[index].length = value;
      this.updateTotals(index);
    },
    quantityChanged(event, index) {
      const value = parseFloat(event) || 0;
      this.items[index].quantity = value;
      this.updateTotals(index);
    },
    unitPriceChanged(event, index) {
      const value = parseFloat(event) || 0;
      this.items[index].unit_price = value;
      this.updateTotals(index);
    },
    toNum(v) {
      const n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    },
    round2(n) {
      return Math.round((Number(n) || 0) * 100) / 100;
    },
    computeLine(item) {
      const len = this.toNum(item.length);

      // ดึง quantity แบบรองรับทั้ง quantity / qty
      let qtyRaw;
      if (item.quantity !== undefined && item.quantity !== null) {
        qtyRaw = this.toNum(item.quantity);
      } else if (item.qty !== undefined && item.qty !== null) {
        qtyRaw = this.toNum(item.qty);
      } else {
        qtyRaw = 0;
      }

      // ✅ ถ้า qty = 0 ให้มองเป็น 1
      const qty = qtyRaw === 0 ? 1 : qtyRaw;

      const up = this.toNum(item.unit_price);

      let total_length, total_price;
      if (len === 0) {
        total_length = qty;
        total_price = qty * up;
      } else {
        total_length = len * qty;
        total_price = total_length * up;
      }

      return {
        total_length: this.round2(total_length),
        total_price: this.round2(total_price),
      };
    },
    updateTotals(index) {
      const item = this.items[index];
      const { total_length, total_price } = this.computeLine(item);
      item.total_length = total_length;
      item.total_price = total_price;
      this.calculateTotals();
    },
    calculateTotals() {
      let itemsTotal = 0;
      this.items.forEach((item) => {
        const price = parseFloat(item.total_price) || 0;
        itemsTotal += price;
      });
      itemsTotal = this.round2(itemsTotal);
      this.itemsTotal = itemsTotal;

      // มิเรอร์สูตรฝั่ง backend (createFullTaxInvoice) เป๊ะ เพื่อให้ยอดบนจอ = ยอดที่บันทึกจริง
      // กติกา: มัดจำหักจาก "ยอดก่อน VAT หลังหักส่วนลด" โดย this.deposit เป็นยอดก่อน VAT
      const vatType = this.form.vat_type;
      const r = this.vatRate;
      const headerDiscount = this.round2(this.toNum(this.discount));
      let deposit = this.round2(this.toNum(this.deposit));
      if (deposit < 0) deposit = 0;

      // มีใบกำกับมัดจำอ้างอิง → ยึดเงินจริง (ฝั่งรวม VAT) กันเศษสตางค์ — มิเรอร์ backend
      // การลบเลขที่ปัดเศษแล้วสองตัวแล้วคูณ VAT ทำให้สุทธิเพี้ยน 1 สต. (เช่น 30,000.01 แทน 30,000.00)
      // ใช้เฉพาะ vatType 2 (รวม VAT) เท่านั้น — vatType 1 (แยก VAT) ต้องได้ VAT = ฐาน × 7% เป๊ะ
      // เศษ ±0.01 ยอมให้ตกที่ยอดสุทธิ ห้ามบวกเข้า VAT
      const refGrand = this.toNum(this.deposit_ref_grand);
      const useRefAnchor = refGrand > 0 && deposit > 0 && vatType === 2;

      if (vatType === 2) {
        // รวม VAT: คำนวณจาก gross (VAT-inclusive) ตลอด ไม่ round ระหว่างทาง
        // gross = items - discount - depositGross
        // (depositGross = grand ใบมัดจำอ้างอิงถ้ามี — เงินที่ลูกค้าจ่ายจริง; ไม่มี ref = deposit×(1+r))
        // vat   = gross × 7/107  → round2 ครั้งเดียว
        // subtotal = gross - vat  → preVat + vat = total เสมอ
        const depositGross = useRefAnchor ? refGrand : deposit * (1 + r);
        const gross = Math.max(itemsTotal - headerDiscount - depositGross, 0);
        this.vat = this.round2(gross * r / (1 + r));
        this.subtotal = this.round2(gross - this.vat);
        this.total = this.round2(gross);
      } else {
        // แยก VAT (1) / ไม่มี VAT (0) — รวมเคสมีใบกำกับมัดจำอ้างอิงด้วย
        // VAT = ฐานหลังหักมัดจำ × 7% เป๊ะเสมอ, สุทธิ = ฐาน + VAT
        let baseAfterDiscount = this.round2(itemsTotal - headerDiscount);
        if (baseAfterDiscount < 0) baseAfterDiscount = 0;
        let baseAfterDeposit = this.round2(baseAfterDiscount - deposit);
        if (baseAfterDeposit < 0) baseAfterDeposit = 0;
        this.subtotal = baseAfterDeposit;
        this.vat = vatType === 0 ? 0 : this.round2(baseAfterDeposit * r);
        this.total = this.round2(baseAfterDeposit + this.vat);
      }
    },
    // วันที่เอกสารเลือกได้ถึงวันนี้ — ห้ามวันอนาคต (ตอนสร้างเลขรันตามเดือนของวันที่)
    // โหมดแก้ไขเปลี่ยนวันได้อิสระ ข้ามเดือนได้ — เลขเอกสารคงเดิมเสมอ ไม่ regen
    disableFutureDates(date) {
      const endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      return date > endOfToday;
    },
    clearDeposit() {
      this.deposit_document_no = null;
      this.deposit_document_id = null;
      this.deposit_tax_invoice_no = null;
      this.deposit_tax_invoice_id = null;
      this.deposit = 0;
      this.deposit_ref_grand = null;
      this.calculateTotals();
    },
    // เลือกใบกำกับภาษีมัดจำ (AI) มาหัก — ล้างมัดจำจากใบ IV ทิ้ง (ใช้ได้ทางเดียว)
    onDepositTaxInvoiceSelected(e) {
      this.depositTaxInvoiceEnabled = false;
      if (!e.status || !e.data) return;

      const data = e.data;
      this.deposit_document_no = null;
      this.deposit_document_id = null;
      this.deposit_tax_invoice_id = data.id;
      this.deposit_tax_invoice_no = data.document_no;

      // grand_total ของใบ AI = ยอดรวม VAT (เงินที่ลูกค้าจ่ายจริง)
      // backend หักมัดจำจากฐานก่อน VAT จึงเก็บ this.deposit เป็นยอดก่อน VAT
      const depGrandTotal = this.toNum(data.grand_total);
      this.deposit_ref_grand = depGrandTotal > 0 ? depGrandTotal : null;
      this.deposit = this.round2(depGrandTotal / (1 + this.vatRate));
      if (this.deposit < 0) this.deposit = 0;

      this.calculateTotals();
    },
    onInitDepositDocumentSettings(e) {
      this.depositDocumentEnabled = false;
      if (e.status) {
        const data = e.data;

        this.deposit_document_id = data.id
        this.deposit_document_no = data.document_no
        // เอกสารมัดจำคือ "ใบกำกับภาษีเต็มรูป" ที่ตั้งเป็นมัดจำ — grand_total เป็นยอดรวม VAT แล้ว
        // backend หักมัดจำจากฐานก่อน VAT จึงต้องเก็บ this.deposit เป็น "ยอดก่อน VAT ของมัดจำ"
        const depGrandTotal = this.toNum(data.grand_total ?? data.grandtotal ?? data.subtotal)
        this.deposit_ref_grand = depGrandTotal > 0 ? depGrandTotal : null
        this.deposit = this.round2(depGrandTotal / (1 + this.vatRate))
        if (this.deposit < 0) this.deposit = 0

        this.calculateTotals();
      }
    }
  }
};
